import { format, isValid, parseISO } from 'date-fns'

import { DATE_FULL_FORMAT_FROM_TIME } from '../../../../../../constants/date'
import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../../../../constants/rentalPortal'
import { MATCH_PROVENANCE_TEXT_KEY } from '../../../../RentalPortalMatch'

import { MATCH_SUGGESTION_STATUS_DEFERRED } from './ApplicantFitCheckBlockSuggestion.constants'

export function getApplicantFitCheckSuggestionTooltip({ suggestion, t }) {
  if (getIsApplicantFitCheckSuggestionDeferred(suggestion)) {
    return t('RentalPortal.MatchReasonDeferredToScreeningKey')
  }

  const at = suggestion.at ? parseISO(suggestion.at) : null

  const provenanceText = t(MATCH_PROVENANCE_TEXT_KEY[suggestion.source])

  const parts = []

  if (provenanceText) {
    parts.push(provenanceText)
  }

  if (at && isValid(at)) {
    parts.push(format(at, DATE_FULL_FORMAT_FROM_TIME))
  }

  return parts.join(RENTAL_PORTAL_FACT_SEPARATOR)
}

export function getIsApplicantFitCheckSuggestionDeferred(suggestion) {
  return suggestion.status === MATCH_SUGGESTION_STATUS_DEFERRED
}
